import { render, staticRenderFns } from "./buyer-information.vue?vue&type=template&id=42402231&"
import script from "./buyer-information.vue?vue&type=script&lang=js&"
export * from "./buyer-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports